import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';
import FullstoryUtil from 'fullstory_util';
import ClickOutsideToDismiss from 'core/components/ClickOutsideToDismiss';
import { ResponsiveCheck } from 'core/providers/Responsive';
import { getCartCount, filterEmptyCarts } from 'cart/utils';

import {
	ShopBagContainer,
	ShopBagIcon,
	BagCounter,
} from './styles';
import CartList from './CartList';
import { getColor } from 'core/utils';

class ShopBag extends React.Component {
	state = {
		open: false,
		carts: [],
		loading: true,
		count: this.props.cartCount || 0,
	}

	componentDidMount() {
		const cartCount = Cookies.get('cartCount');
		if (cartCount) {
			this.setState({ count: cartCount });
		}

		this.listenForCarts();
	}

	componentWillUnmount() {
		window.removeEventListener('ShopBag.setCarts', this.handleSetCarts);
	}

	listenForCarts() {
		window.addEventListener('ShopBag.setCarts', this.handleSetCarts);
	}

	handleSetCarts = (evt) => {
		const { detail } = evt;
		const carts = detail?.carts || [];
		const count = getCartCount(carts);
		this.setState({ carts, count });
	}

	toggleOpen = () => {
		const { open } = this.state;
		this.setState({ open: !open });
		const { toggleBottomEnabled } = this.props;
		if (toggleBottomEnabled) {
			toggleBottomEnabled(open);
		}

		FullstoryUtil.sendEvent('cartOpened');
	};

	close = () => {
		if (this.state.open) this.toggleOpen();
	};

	removeItem = cartProductId => {
		// Update the UI ASAP
		let open = true; // keep it open?
		let { carts } = this.state;
		carts.forEach(cart => {
			// remove from its cart
			cart.products = cart.products.filter(cp => cp.id !== cartProductId);
		});
		carts = filterEmptyCarts(carts);
		const newCount = getCartCount(carts);
		if (newCount === 0) open = false;
		this.setState({ count: newCount, carts: carts, open });

		// Dispatch updates to ShopBag (Triggers DELETE API call)
		const evt = new CustomEvent('ShopBag.removeItem', { detail: cartProductId });
		window.dispatchEvent(evt);
	};

	render() {
		const { open, carts, count } = this.state;
		return (
			<ResponsiveCheck>
				{({ isDesktop }) => (
					<ClickOutsideToDismiss onClose={this.close} active={open}>
						<Fragment>
							<ShopBagContainer onClick={() => this.toggleOpen()} aria-label="Toggle Shopping Cart">
								<ShopBagIcon stroke={getColor("black")} />
								{count ? <BagCounter>{isDesktop ? count : ''}</BagCounter> : null}
							</ShopBagContainer>
							<CartList open={open} onClose={this.close} removeItem={this.removeItem} carts={carts} />
						</Fragment>
					</ClickOutsideToDismiss>
				)}
			</ResponsiveCheck>
		);
	}
}

ShopBag.propTypes = {
	cartCount: PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string,
	]),
	toggleBottomEnabled: PropTypes.func,
};

export default ShopBag;
